import { Label, CustomOverlay } from '@uiw/react-baidu-map';
import { BaiduMapMarkerProps } from './BaiduMapMarker.types';
import { FC } from 'react';
import { OverlayWrapper } from './BaiduMapMarker.styles';

export const BaiduMapMarker: FC<BaiduMapMarkerProps> = ({
  position,
  label,
  className = '',
  onClick,
  children,
  offset,
  customOverlay,
  ...props
}) => {
  if (customOverlay) {
    return (
      <CustomOverlay position={position}>
        <OverlayWrapper className={className} onClick={onClick} {...props}>
          <img src={customOverlay} width={117} height={76} style={{ margin: 0 }} alt={label} />
        </OverlayWrapper>
      </CustomOverlay>
    );
  }
  return (
    <Label
      position={position}
      style={{ border: 'none', backgroundColor: 'none', transform: 'translate(-50%, -100%)' }}
      onClick={onClick}
      offset={offset}
    >
      <span className={`m-map-pin ${className}`} {...props}>
        {label}
        {children}
      </span>
    </Label>
  );
};
